import { useEffect } from 'react';
import EVENTS from '@/utils/Constants/Events';

// Context
import { useCompareContext } from '@/context/compare';

export default () => {
  const [, { clearCompare }] = useCompareContext();

  useEffect(() => {
    DLG.EVE.on(EVENTS.LISTING.COMPARE.CLEAR, () => clearCompare());
  }, []);
};
